import { Label } from '@/components/ui/label';
import { InfoTooltip } from '@/components/help/InfoTooltip';

export function LabelWithHint({
  htmlFor,
  label,
  hint,
  className,
}: {
  htmlFor?: string;
  label: string;
  hint: string;
  className?: string;
}) {
  return (
    <div className={`flex items-center gap-1 ${className ?? ''}`}>
      <Label htmlFor={htmlFor} className="text-xs">
        {label}
      </Label>
      <InfoTooltip text={hint} />
    </div>
  );
}
